import { Modal, Button, Typography } from "antd";
import React from "react";

const { Text } = Typography;

interface MergeConfirmModalProps {
    open: boolean;
    status: string;
    childAddressCount: number | undefined;
    childSocietyName: string;
    parentSocietyName: string;
    onCancel: () => void;
    onConfirm: () => void;
}

export const MergeConfirmModal: React.FC<MergeConfirmModalProps> = ({
    open,
    status,
    childAddressCount,
    childSocietyName,
    parentSocietyName,
    onCancel,
    onConfirm,
}) => {
    return (
        <Modal
            title={null}
            open={open}
            onCancel={onCancel}
            width={450}
            centered
            footer={
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                    <Button onClick={onCancel} disabled={status === "saving"}>
                        Cancel
                    </Button>
                    <Button type="primary" onClick={onConfirm} loading={status === "saving"}>
                        Confirm
                    </Button>
                </div>
            }
        >
            <div style={{ textAlign: "center", padding: "20px 0" }}>
                <Text style={{ color: "#d32f2f", fontSize: "16px", fontWeight: "600", display: "block", marginBottom: "12px" }}>
                    {childAddressCount} addresses will be affected by this action.
                </Text>
                <Text style={{ fontSize: "14px", color: "#262626", display: "block" }}>
                    Are you sure to merge '{childSocietyName}' into '{parentSocietyName}' society?
                </Text>
            </div>
        </Modal>
    );
};
